<template>
  <a-modal
      :title="'修改' + (item && item.label ? item.label : '')"
      :width="500"
      :visible="visible"
      :confirmLoading="false"
      @ok="() => { $emit('ok') }"
      @cancel="() => { $emit('cancel') }"
  >
    <a-form-model ref="adminForm" :model="form" :label-col="{span:6}" :wrapper-col="{span:15}" autoComplete="off">
      <a-form-model-item v-show="false" label="field" prop="field">
        <a-input v-model="form.field" type="hidden" />
      </a-form-model-item>
      <a-form-model-item :label="item && item.label" prop="val"
        :rules="[{ required: true, message: '必填，不能为空', trigger: 'blur' }]">
        <a-input v-model="form.val" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: {
        field: '',
        val: ''
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.syncFromItem();
      }
    },
    item: {
      deep: true,
      handler() {
        if (this.visible) {
          this.syncFromItem();
        }
      }
    }
  },
  methods: {
    syncFromItem() {
      const it = this.item || {};
      this.form = {
        field: it.field || '',
        val: it.val != null ? String(it.val) : ''
      };
      this.$nextTick(() => {
        if (this.$refs.adminForm) {
          this.$refs.adminForm.clearValidate();
        }
      });
    },
    initForm() {
      this.form = { field: '', val: '' };
      this.$nextTick(() => {
        if (this.$refs.adminForm) {
          this.$refs.adminForm.clearValidate();
        }
      });
    }
  }
}
</script>
